"use strict";
import Browser from './../util/browser';

class Ashiato{
	constructor($con){
		this.$con = $con;
		this.init();
		
		Browser.addResponsiveHandler(this.resizeHandler , this);
		this.resizeHandler();
	}
	
	init(){
		this.addAshiato(1,6,'right',{left:-80,top:360},45);
		this.addAshiato(2,6,'left',{left:120,top:360+520},135);
		this.addAshiato(3,6,'right',{left:-80,top:360+520+438},45);
		this.addAshiato(4,6,'left',{left:120,top:360+520+438+505},135);
		this.addAshiato(5,6,'right',{left:-80,top:360+520+438+505+424},45);
		this.addAshiato(6,6,'left',{left:120,top:360+520+438+505+424+514},135);
		this.addAshiato(7,8,'right',{left:-80,top:360+520+438+505+424+514+418},45);
	}
	
	addAshiato(group,num,direction,grouppos,angle){
		let h = '';
		h += '<div class="group group'+group+'">';
		for(var i=0;i<num;i++){
			h += '<div class="ashiato '+direction+'"></div>';			
		}
		h += '</div>';
		this.$con.append(h);
		
		let $group = this.$con.find('.group'+group);
		$group.css(grouppos);
		$group.data('group',group);
		$group.data('num',num);
		$group.data('direction',direction);
		$group.data('grouppos',grouppos);
		$group.data('angle',angle);
		
		this.resize($group);
	}

	resize($group){
		var group = $group.data('group');
		var num = $group.data('num');
		var direction = $group.data('direction');
		var grouppos = $group.data('grouppos');
		var angle = $group.data('angle');
				
		var rad = angle * Math.PI / 180;
		var distance = 50;
		var offset = 20;
		if(Browser.responsive == 'sp'){
			distance = Browser.windowWidth * 0.1;
			offset = Browser.windowWidth * 0.04;
		}
		var cos = Math.cos(rad);
		var sin = Math.sin(rad);
				
		$group.find('.ashiato').each((i,v)=>{
			var x = Math.floor(distance * i * cos);
			var y = Math.floor(distance * i * sin);
			if(i%2==1){
				if(direction == 'right'){
					x += -offset;
					y += offset;
					if(Browser.responsive == 'sp'){
						x += -offset;
						y += offset;						
					}
				} else if(direction == 'bottom'){
					x += -offset*1.75;				
				} else {
					x += -offset;
					y += -offset;
				}

			}
			$(v).css({left:x,top:y}).velocity({scaleX:0,scaleY:0},1);
		})
	}
		
	resizeHandler(){
		this.$con.find('.group').each((i,v)=>{
			this.resize( $(v) );
		});
	}
	
	open(idx){
		this.$con.find('.group'+idx+' .ashiato').each((i,v)=>{
			var move = {x:-2,y:-2};
			if($(v).hasClass('left')){
				move = {x:2,y:-2};
			}
			$(v).velocity('stop').velocity({translateX:[0,move.x],translateY:[0,move.y],scaleX:[1,0],scaleY:[1,0]},{duration:280,delay:i*70});
		});
	}
	
	close(idx,duration){
		if(typeof duration !== 'number') duration = 100;
		this.$con.find('.group'+idx+' .ashiato').each((i,v)=>{
			$(v).velocity('stop').velocity({scaleX:0,scaleY:0},{duration:duration});						
		});
	}
}

export default Ashiato;


// WEBPACK FOOTER //
// ./js/parts/ashiato.js